import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "./pages/login/login";
// import AdminDashboard from './pages/admin/adminDashboard';
import Dashboard from "./pages/dashboard/dashboard";
import useAuth from "./api/useAuth";
import "./App.css";
import Settings from "./pages/settings/settings";
import { Toaster } from "react-hot-toast";

const PrivateRoute = ({ element: Element, ...rest }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return isAuthenticated ? <Element {...rest} /> : <Navigate to="/login" />;
};

function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* Ruta pública */}
          <Route path="/login" element={<Login />} />

          {/* Rutas protegidas */}
          <Route
            path="/dashboard"
            element={<PrivateRoute element={Dashboard} />}
          />
          <Route
            path="/settings"
            element={<PrivateRoute element={Settings} />}
          />

          {/* Redirigir cualquier otra ruta a /login */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>

      {/* Coloca <Toaster /> una sola vez al final */}
      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
}

export default App;
